import isPaymentScheduleEnabled from 'checkout/selectors/payment/paymentSchedule/isPaymentScheduleEnabled'
import Clickable from 'components/Common/Clickable'
import FormatCurrency from 'components/Common/FormatCurrency'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import FormatPercent from 'components/utils/Formatters/FormatPercent'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import type { MouseEventHandler } from 'react'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  paymentScheduleTemplate: App.Tours.TourPaymentScheduleTemplate
  onInfoClick?: () => void
}

function TourDepositTag({ paymentScheduleTemplate, onInfoClick }: Props) {
  const intl = useIntl()
  const deposit = paymentScheduleTemplate.schedules[0]

  const handleInfoClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    onInfoClick!()
  }, [onInfoClick])

  if (!deposit) return null

  return <CaptionTextBlock
    variant="large"
    weight="bold"
    colour="highlight-primary-dark"
    endIcon={!!onInfoClick && <Clickable onClick={handleInfoClick}><LineInfoCircleIcon colour="normal-contrast" /></Clickable>}
  >
    {intl.formatMessage(
      {
        id: '0Nj0mw2C7cPrb3nTjpbw',
        defaultMessage: 'Secure with {amount} deposit',
        description: 'Deposit tag showing the amount or percentage required to secure a booking',
      },
      {
        amount: deposit.amountType === 'percentage'
          ? <FormatPercent value={deposit.amountValue} />
          : <FormatCurrency value={deposit.amountValue} />,
      },
    )}
  </CaptionTextBlock>
}

export default withMountGuard(() => {
  return useAppSelector(isPaymentScheduleEnabled)
})(TourDepositTag)
